import API from '@/api';
import UtilsMixins from './UtilsMixins';
import FirmPreferenceMixins from './FirmPreferenceMixins';

export default {
  mixins: [UtilsMixins, FirmPreferenceMixins],
  data() {
    return {
      statusTypes: [
        {
          id: 0,
          text: 'All',
          value: 'all',
          class: 'grey--text',
        },
        {
          id: 1,
          text: 'Processing',
          value: 'processing',
          class: '',
          icon: 'pending',
        },
        {
          id: 1,
          text: 'Ready to be Exported',
          value: 'action_required',
          class: 'warning white--text',
          icon: 'warning',
        },
        {
          id: 2,
          text: 'Scheduled',
          value: 'scheduled',
          class: 'primary white--text',
          icon: 'access_time_filled',
        },
        {
          id: 3,
          text: 'In Progress',
          value: 'in_progress',
          class: '',
          icon: 'more_horiz',
        },
        {
          id: 4,
          text: 'Exported',
          value: 'completed',
          class: 'success white--text',
          icon: 'check_circle',
        },
        {
          id: 5,
          text: 'Failed',
          value: 'failed',
          class: 'error white--text',
          icon: 'cancel',
        },
        {
          id: 6,
          text: 'Not exportable',
          value: 'not_exportable',
          class: 'error white--text',
          icon: 'cancel',
        },
        // For Soraban Admin
        {
          id: 7,
          text: 'In Progress',
          value: 'in_qa',
          class: '',
          icon: 'more_horiz',
        },
        {
          id: 8,
          text: 'In Progress',
          value: 'system_failure',
          class: '',
          icon: 'more_horiz',
        },
        {
          id: 9,
          text: 'Already E-filed',
          value: 'already_e_filed',
          class: 'error white--text',
          icon: 'cancel',
        },
      ],
      preorderedForms: [
        'W-2',
        'W-2G',
        '1099-NEC',
        '1099-MISC',
        '1099-OID',
        '1099-K',
        '1099-DIV',
        '1099-INT',
        'Brokerage Statement',
        '1065 K-1',
        '1120S K-1',
        '1041 K-1',
        '1099-R',
        '1098-T',
        '1099-G',
        '1098',
      ],
      basicSupportedTaxFormsForDataEntry: ['W-2', '1099-DIV', '1099-INT'],
      ultraTaxSupportedForms: [
        '1099-R',
        '1099-NEC',
        '1065 K-1',
        '1120S K-1',
        '1099-MISC',
        '1099-OID',
        '1098',
        'Brokerage Statement',
        'W-2G',
      ],
      drakeSupportedForms: [
        '1099-G',
        '1099-R',
        '1099-NEC',
        '1099-K',
        '1099-MISC',
        '1098-T',
        '1098',
        '1065 K-1',
        '1120S K-1',
        'Brokerage Statement',
        'W-2G',
      ],
      lacerteSupportedForms: [
        '1099-G',
        '1099-R',
        '1098-T',
        '1065 K-1',
        '1120S K-1',
        'W-2G',
        'Brokerage Statement',
        '1041 K-1',
        '1099-MISC',
        '1099-NEC',
        '1099-Q',
        'SSA-1099',
      ],
    };
  },
  computed: {
    hasUltraTax() {
      return this.currentFirm.tax_softwares.includes('UltraTax');
    },
    hasDrake() {
      return this.currentFirm.tax_softwares.includes('Drake');
    },
    hasLacerte() {
      return this.currentFirm.tax_softwares.includes('Lacerte');
    },
    hasAxcess() {
      return this.currentFirm.tax_softwares.includes('Axcess');
    },

    taxIdFilled() {
      return (
        !!this.selectedEntity.tax_return_id || !!this.selectedEntity.spouse_ssn
      );
    },

    supportedTaxFormsForDataEntry() {
      let supportedForms = this.basicSupportedTaxFormsForDataEntry;
      if (this.currentFirm.tax_softwares.includes('Drake')) {
        supportedForms = supportedForms.concat(this.drakeSupportedForms);
      } else if (this.currentFirm.tax_softwares.includes('UltraTax')) {
        supportedForms = supportedForms.concat(this.ultraTaxSupportedForms);
      } else if (this.currentFirm.tax_softwares.includes('Lacerte')) {
        supportedForms = supportedForms.concat(this.lacerteSupportedForms);
      }

      return supportedForms;
    },
    selectedForm() {
      if (this.questionnaire) {
        return this.selectableForms[this.activeTab];
      } else {
        return null;
      }
    },
    exportableFormNames() {
      return this.exportableForms.map(form => form.name);
    },
    exportableTaxForms() {
      return this.documents.filter(
        doc =>
          doc.document_type === 'tax_form' &&
          this.exportableFormNames.includes(doc.name),
      );
    },
    showBeginExportButton() {
      return (
        this.sorabanConnectDemoEnabled ||
        this.getIsSorabanAdvisorAdmin(this.currentUser)
      );
    },
  },
  methods: {
    async updateExtractedDocument(doc) {
      try {
        const response = await API.extractedDocument.updateExtractedDocument({
          companyId: doc.company_id,
          extractedDocumentId: doc.id,
          status: doc.status,
        });
        if (response.data.error) {
          console.log(response.data.error);
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Successfully saved.',
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.$emit('refresh');
      }
    },
    async toggleExtractedDocumentReviewed(doc) {
      if (doc.reviewer_id) {
        doc.reviewer_id = null;
        doc.reviewer_name = null;
        doc.reviewed_at = null;
      } else {
        doc.reviewer_id = this.currentUser.id;
        doc.reviewer_name = this.currentUser.full_name;
        doc.reviewed_at = new Date();
      }
      try {
        const response = await API.extractedDocument.updateExtractedDocument({
          companyId: doc.company_id,
          extractedDocumentId: doc.id,
          reviewStatus: doc.reviewer_id ? 'mark_reviewed' : 'unmark_review',
        });
        if (response.data.error) {
          console.log(response.data.error);
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Successfully saved.',
          });
          doc = response.data;
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.$emit('refresh');
        this.$forceUpdate();
      }
    },

    findStatus(status_key) {
      return this.statusTypes.find(status => status.value === status_key);
    },
    matchedForm(selectedForm) {
      return this.exportableForms.find(form => form.name === selectedForm.name);
    },
    async getExportableForms() {
      try {
        const response = await API.extractedDocument.getExportableForms();
        this.exportableForms = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    downloadDemoLeadsheet() {
      document.getElementById('my_iframe').src =
        'https://drive.google.com/uc?export=download&id=13hAANjEVbgc4CYCNZB-bub9pTDO4na7i';
    },

    async downloadLeadsheet(selectedEntity) {
      const response = await API.extractedDocument.downloadLeadsheet({
        companyId: selectedEntity.id,
        year: this.selectedYear,
      });
      if (response.data.error) {
        this.$store.dispatch('application/setErrorNotification', {
          message: response.data.error,
        });
      } else {
        this.saveAs(
          response.data,
          `${selectedEntity.tax_return_name} - Leadsheet.xls`,
        );
      }
    },
  },
};
